import axios from 'axios'
import library from '../../../utils/Library'

export const getSubscriberSuscriptionCommProduct = async (subscriberID, size = 50, page = 1) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('customers_and_products_api') +
    `/getSubscriberSuscriptionCommProduct/${subscriberID}?size=${size}&page=${page}`

  return await axios.get(URL, {
    headers: {
      Authorization: `Bearer ${TOKEN}`
    }
  })
}
